.chip {
  border: 1px solid light-dark(var(--mantine-color-gray-4), var(--mantine-color-dark-4));
  border-radius: var(--mantine-radius-xl);
  padding: 6px 12px;
  transition: border-color 150ms ease, background-color 150ms ease;
}

.chipSelected {
  border-color: light-dark(var(--mantine-color-primary-7), var(--mantine-color-primary-4));
  background-color: light-dark(var(--mantine-color-primary-0), var(--mantine-color-primary-9));
}

.dot {
  border-radius: 50%;
  flex-shrink: 0;
  height: 8px;
  width: 8px;
}

.label {
  white-space: nowrap;
}
